import { Grid } from "@chakra-ui/layout"

function SnippetGrid(props) {
  return (
    <Grid
      gridTemplateColumns={[
        'repeat(auto-fill, 100%)',
        'repeat(auto-fill, 100%)',
        'repeat(2, 1fr)',
        'repeat(3, 1fr)'
      ]}
      gridGap={6}
      {...props}
    />
  )
}

export default SnippetGrid
